import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Recta/addRecta`, method: 'POST', body: values, token: token})
}
